// import React, { useState, useEffect, useContext } from 'react'
// import AdminContext from '../../../StateContext/Application';
// import { apiurl } from '../../../../../path';
// import { useLanguage } from '../../../../../lang/langcontext/LanguageContext';
// const LimitOutward = () => {
//         const { language, toggleLanguage, t } = useLanguage();
//     const context = useContext(AdminContext)
//     const { GetBudgetHeadInfo, TechnicalOutwards } = context;

//     const [LimitType, setLimitType] = useState('Work');
//     const [technicalInwards, setTechnicalInwards] = useState([])
//     const [selectedBills, setSelectedBills] = useState([]);
//     const [filteredBills, setFilteredBills] = useState([]);
//     const [selectedProposal, setSelectedProposal] = useState(null);
//     const [proposallist, setProposalList] = useState([])
//     const [currentPage, setCurrentPage] = useState(1);
//     const billsPerPage = 10;
//     const [searchTerm, setSearchTerm] = useState('');
//     const budgetEstimation = proposallist;

//     const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
//     const indexOfLastBill = currentPage * billsPerPage;
//     const indexOfFirstBill = indexOfLastBill - billsPerPage;
//     const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

//     const headerStyle = {
//         padding: "12px 16px",
//         whiteSpace: "nowrap",
//         borderRight: "1px solid #e0e0e0",
//         textTransform: "capitalize",
//     };


//     const getTechnicalInwardsList = async () => {
//         let data = await GetBudgetHeadInfo('All', 'GetDemandGenerationList')
//         let data1 = await TechnicalOutwards("LimitAllocation")
//         console.log("data------------", data1);

//         let filterDataonLimitType;

//         if (LimitType == "Work") {
//             filterDataonLimitType = data1.filter((item) => item.Release_Type == LimitType);
//         }
//         else {
//             filterDataonLimitType = data1.filter((item) => item.Release_Type == "Head");
//         }


//         setTechnicalInwards(data)
//         setProposalList(filterDataonLimitType)
//     }

//     useEffect(() => {
//         getTechnicalInwardsList()
//     }, [LimitType]);

//     let inwardList = []
//     if (technicalInwards.length > 0) {
//         inwardList = technicalInwards
//     }
//     useEffect(() => {
//         const lowerSearchTerm = searchTerm.toLowerCase();
//         const filtered = technicalInwards.filter(bill =>
//             Object.values(bill).some((val) =>
//                 (val || '').toString().toLowerCase().includes(lowerSearchTerm)
//             )
//         );
//         setFilteredBills(filtered);
//         setCurrentPage(1);
//     }, [searchTerm, technicalInwards]);



//     useEffect(() => {
//         const lowerSearchTerm = searchTerm.toLowerCase();
//         const filtered = budgetEstimation.filter(bill =>
//             Object.values(bill).some((val) =>
//                 (val || '').toString().toLowerCase().includes(lowerSearchTerm)
//             )
//         );
//         setFilteredBills(filtered);
//         setCurrentPage(1);
//     }, [searchTerm, budgetEstimation]);


//     const selectedBillDetails = (BillID, year) => {
//         if (LimitType === "Proposal") {
//             const result = budgetEstimation
//                 .filter(item => item.ProposalID == BillID)
//                 .map(item => ({
//                     "Release UID": item.ReleaseID,
//                     "Proposal Name": item.ProposalID,
//                     "Head Code": item.HeadCode,
//                     "District": item.District,
//                     "Taluka": item.Taluka,
//                     "Proposal Cost": item.ProposalCost,
//                     "Limit Allocated": item.OriginalLimitAllocatedAmount,
//                     "Release Amount Till Date": item.ReleaseAmountTillDate,
//                     "Release Draft Copy": item.ReleaseSanctionCopy,
//                     "Date": new Date(item.Date).toLocaleString(),
//                 }));


//             console.log("------------------", result)
//             setSelectedProposal(result[0]);
//         }
//         else if (LimitType === "Head") {
//             const result = budgetEstimation
//                 .filter(item => item.Release_Type == "Head" && item.HeadCode == BillID && item.FinancialYear == year)
//                 .map(item => ({
//                     "Release UID": item.ReleaseID,
//                     "Head Code": item.HeadCode,
//                     "Head Name": item.BudgetHead,
//                     "District": item.District,
//                     "Limit Allocated": item.OriginalLimitAllocatedAmount,
//                     "Release Amount Till Date": item.ReleaseAmountTillDate,
//                     "Date": new Date(item.Date).toLocaleString(),
//                 }));


//             console.log("------------------", result)
//             setSelectedProposal(result[0]);
//         }
//     }


//      return (

//         <>

//             <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>

//                 <div className="col-11 m-auto">
//                     <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                         <h5 className='my-auto fw-bold'>
//                             <img src="/Work-Order-Outwards-Blue64.png" alt="Limit Allocation" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
//                             <span className='my-auto '>{t("Limit Allocation Outward")}</span>
//                         </h5>
//                         <div className="col-4 text-start ms-3">
//                             <button className='btn btn-primary me-2' onClick={() => setLimitType("Work")}>{t("Work Wise")}</button>
//                             <button className='btn btn-success' onClick={() => setLimitType("Head")}>{t("Head Wise")}</button>
//                         </div>
//                         <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
//                             <img
//                                 src="/Search32.png"
//                                 alt="Search Icon"
//                                 style={{
//                                     position: "absolute",
//                                     top: "50%",
//                                     left: "10px",
//                                     transform: "translateY(-50%)",
//                                     width: "16px",
//                                     height: "16px",
//                                     opacity: 0.6
//                                 }}
//                             />
//                             <input
//                                 type="text"
//                                placeholder={t("Search Here")}
//                                 onChange={(e) => setSearchTerm(e.target.value)}
//                                 value={searchTerm}
//                                 style={{
//                                     width: "100%",
//                                     padding: "8px 12px 8px 32px",
//                                     border: "1px solid #ccc",
//                                     borderRadius: "8px",
//                                     backgroundColor: "#f1f6fc",
//                                     fontSize: "14px",
//                                     color: "#333",
//                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                     outline: "none"
//                                 }}
//                             />
//                         </div>
//                     </div>

//                     <div className="col-12 pb-5">
//                         <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px" }}>

//                             <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
//                                 {
//                                     LimitType == "Work" &&
//                                     <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                         <thead>
//                                             <tr style={{ color: 'white', border: 'none', height: '3rem',fontSize: "12px", fontWeight: "400" }}>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Sr.No.")}</th>
//                                                 <th style={{ minWidth: "180px", padding: "12px" }} rowSpan={2} colSpan={1}>{t("Work Name")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Release UID")}</th>
//                                                 <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("Head Code")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("District")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Taluka")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Work Cost")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("MHUID Number")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Physical Value In %")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Limit Allocated")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Release Amount Till Date")}</th>
//                                                 {/* <th style={headerStyle} rowSpan={2} colSpan={1}>Release Draft Copy</th> */}
//                                                 <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("Date")}</th>
//                                                 <th style={headerStyle} colSpan={2}>{t("Approved by")}</th> {/* changed from 9 to 7 */}
//                                                 {/* <th style={{ width: "15%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>Details</th> */}
//                                             </tr>
//                                             <tr style={{ color: 'white', border: 'none', height: '3rem',fontSize: "12px", fontWeight: "400" }}>
//                                                 <th style={headerStyle}>{t("RDD Section Officer")}</th>
//                                                 <th style={headerStyle}>{t("Deputy Secretary")}</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody >
//                                             {currentBills?.length === 0 ? (
//                                                 <tr>
//                                                     <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                                                         {t("No data available")}
//                                                     </td>
//                                                 </tr>
//                                             ) : (
//                                                 currentBills?.map((proposal, index) => {
//                                                     const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                     return (
//                                                         <tr style={{ backgroundColor: bgColor,fontSize: "12px", fontWeight: "400" }} key={index}>
//                                                             <td style={{ fontSize: "12px", padding: "5px" }}>{indexOfFirstBill + index + 1}</td>
//                                                             <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.ProposalID}</td>
//                                                             <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.ReleaseID}</td>
//                                                             <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.HeadCode}</td>
//                                                             <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.District}</td>
//                                                             <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.Taluka}</td>
//                                                             <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.ProposalCost}</td>
//                                                             <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.MH_UID}</td>
//                                                             <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.physicalValue}</td>
//                                                             <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.OriginalLimitAllocatedAmount}</td>
//                                                             <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.ReleaseAmountTillDate}</td>
//                                                             {/* <td style={{ padding: '8px' }}>
//                                                                 {proposal.ReleaseSanctionCopy ? (
//                                                                     <a href={`${apiurl}/FinancialReleaseGR/${proposal.ReleaseSanctionCopy}`} target="_blank" rel="noreferrer">{proposal.ReleaseSanctionCopy}</a>
//                                                                 ) : (
//                                                                     <p className='text-danger my-auto fw-bold'>No File</p>
//                                                                 )
//                                                                 }
//                                                             </td> */}
//                                                             <td  style={{ fontSize: "12px", padding: "5px" }}>{new Date(proposal.Date).toLocaleString()}</td>
//                                                             <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                 {proposal.Approvance1 === 'true' ? (
//                                                                     <div className='m-auto'
//                                                                         style={{
//                                                                             width: '20px',
//                                                                             height: '20px',
//                                                                             borderRadius: '6px',
//                                                                             backgroundColor: '#16C60C',
//                                                                             border: 'none',
//                                                                             display: 'flex',
//                                                                             justifyContent: 'center',
//                                                                             alignItems: 'center',
//                                                                             fontSize: '13px',
//                                                                             color: 'white',
//                                                                             boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                         }}
//                                                                     >
//                                                                         ✓
//                                                                     </div>
//                                                                 ) : proposal.Approvance1 === 'false' ? (
//                                                                     <div
//                                                                         className='m-auto'
//                                                                         style={{
//                                                                             width: '20px',
//                                                                             height: '20px',
//                                                                             borderRadius: '6px',
//                                                                             backgroundColor: '#dc2626',
//                                                                             border: 'none',
//                                                                             display: 'flex',
//                                                                             justifyContent: 'center',
//                                                                             alignItems: 'center',
//                                                                             fontSize: '13px',
//                                                                             color: 'white',
//                                                                             boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                         }}
//                                                                     >
//                                                                         ✕
//                                                                     </div>
//                                                                 ) : '-'}
//                                                             </td>
//                                                             <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                 {proposal.Approvance2 === 'true' ? (<div className='m-auto'
//                                                                     style={{
//                                                                         width: '20px',
//                                                                         height: '20px',
//                                                                         borderRadius: '6px',
//                                                                         backgroundColor: '#16C60C',
//                                                                         border: 'none',
//                                                                         display: 'flex',
//                                                                         justifyContent: 'center',
//                                                                         alignItems: 'center',
//                                                                         fontSize: '13px',
//                                                                         color: 'white',
//                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                     }}
//                                                                 >
//                                                                     ✓
//                                                                 </div>) : proposal.Approvance2 === 'false' ? (<div
//                                                                     className='m-auto'
//                                                                     style={{
//                                                                         width: '20px',
//                                                                         height: '20px',
//                                                                         borderRadius: '6px',
//                                                                         backgroundColor: '#dc2626',
//                                                                         border: 'none',
//                                                                         display: 'flex',
//                                                                         justifyContent: 'center',
//                                                                         alignItems: 'center',
//                                                                         fontSize: '13px',
//                                                                         color: 'white',
//                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                     }}
//                                                                 >
//                                                                     ✕
//                                                                 </div>) : '-'}
//                                                             </td>

//                                                             {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
//                                                             {/* <td>
//                                                             <button
//                                                                 className='m-auto'
//                                                                 onClick={() => selectedBillDetails(proposal.ProposalID)}
//                                                                 style={{
//                                                                     cursor: 'pointer',
//                                                                     background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                                                                     color: 'white',
//                                                                     border: 'none',
//                                                                     padding: '8px 20px',
//                                                                     borderRadius: '4px',
//                                                                     fontSize: "12px",
//                                                                     display: "flex",
//                                                                     justifyContent: "center",
//                                                                     alignItems: 'center'
//                                                                 }}
//                                                             >
//                                                                 <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
//                                                                 View
//                                                             </button>
//                                                         </td> */}
//                                                         </tr>

//                                                     );
//                                                 })
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 }
//                                 {
//                                     LimitType == "Head" &&
//                                     <table className='m-0 p-0' style={{ width: "100%" }}>
//                                         <thead>
//                                             <tr style={{ color: 'white', border: 'none', height: '3.5rem' }}>
//                                                 <th style={{ width: "25%", border: "1px solid white" }} rowSpan={2} colSpan={1}>{t("Head Name")}</th>
//                                                 <th style={{ width: "40%", border: "1px solid white" }} colSpan={2}>{t("Approved by")}</th> {/* changed from 9 to 7 */}
//                                                 <th style={{ width: "15%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>{t("Details")}</th>
//                                             </tr>
//                                             <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
//                                                 <th style={{ width: "20%", border: "1px solid white" }}>{t("RDD Section Officer")}</th>
//                                                 <th style={{ width: "20%", border: "1px solid white" }}>{t("Deputy Secretary")}</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody >
//                                             {currentBills?.length === 0 ? (
//                                                 <tr>
//                                                     <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                                                        {t("No data available")}
//                                                     </td>
//                                                 </tr>
//                                             ) : (
//                                                 currentBills?.map((proposal, index) => {
//                                                     const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                     return (
//                                                         <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }} key={index}>
//                                                             <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.BudgetHead}</td>
//                                                             <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                 {proposal.Approvance1 === 'true' ? (
//                                                                     <div className='m-auto'
//                                                                         style={{
//                                                                             width: '20px',
//                                                                             height: '20px',
//                                                                             borderRadius: '6px',
//                                                                             backgroundColor: '#16C60C',
//                                                                             border: 'none',
//                                                                             display: 'flex',
//                                                                             justifyContent: 'center',
//                                                                             alignItems: 'center',
//                                                                             fontSize: '13px',
//                                                                             color: 'white',
//                                                                             boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                         }}
//                                                                     >
//                                                                         ✓
//                                                                     </div>
//                                                                 ) : proposal.Approvance1 === 'false' ? (
//                                                                     <div
//                                                                         className='m-auto'
//                                                                         style={{
//                                                                             width: '20px',
//                                                                             height: '20px',
//                                                                             borderRadius: '6px',
//                                                                             backgroundColor: '#dc2626',
//                                                                             border: 'none',
//                                                                             display: 'flex',
//                                                                             justifyContent: 'center',
//                                                                             alignItems: 'center',
//                                                                             fontSize: '13px',
//                                                                             color: 'white',
//                                                                             boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                         }}
//                                                                     >
//                                                                         ✕
//                                                                     </div>
//                                                                 ) : '-'}
//                                                             </td>
//                                                             <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                 {proposal.Approvance2 === 'true' ? (<div className='m-auto'
//                                                                     style={{
//                                                                         width: '20px',
//                                                                         height: '20px',
//                                                                         borderRadius: '6px',
//                                                                         backgroundColor: '#16C60C',
//                                                                         border: 'none',
//                                                                         display: 'flex',
//                                                                         justifyContent: 'center',
//                                                                         alignItems: 'center',
//                                                                         fontSize: '13px',
//                                                                         color: 'white',
//                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                     }}
//                                                                 >
//                                                                     ✓
//                                                                 </div>) : proposal.Approvance2 === 'false' ? (<div
//                                                                     className='m-auto'
//                                                                     style={{
//                                                                         width: '20px',
//                                                                         height: '20px',
//                                                                         borderRadius: '6px',
//                                                                         backgroundColor: '#dc2626',
//                                                                         border: 'none',
//                                                                         display: 'flex',
//                                                                         justifyContent: 'center',
//                                                                         alignItems: 'center',
//                                                                         fontSize: '13px',
//                                                                         color: 'white',
//                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                     }}
//                                                                 >
//                                                                     ✕
//                                                                 </div>) : '-'}
//                                                             </td>

//                                                             {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
//                                                             <td>
//                                                                 <button
//                                                                     className='m-auto'
//                                                                     onClick={() => selectedBillDetails(proposal.BudgetHeadID, proposal.FinancialYear)}
//                                                                     style={{
//                                                                         cursor: 'pointer',
//                                                                         background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                                                                         color: 'white',
//                                                                         border: 'none',
//                                                                         padding: '8px 20px',
//                                                                         borderRadius: '4px',
//                                                                         fontSize: "12px",
//                                                                         display: "flex",
//                                                                         justifyContent: "center",
//                                                                         alignItems: 'center'
//                                                                     }}
//                                                                 >
//                                                                     <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
//                                                                     {t("View")}
//                                                                 </button>
//                                                             </td>
//                                                         </tr>

//                                                     );
//                                                 })
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 }
//                             </div>
//                             <div className='col-12 mt-4'>
//                                 <div className="row">
//                                     <div className='col-6'>
//                                         <p className="text-gray-600" style={{ fontSize: "14px", margin: 0 }}>{t("Showing")} {indexOfFirstBill + 1} {t("to")} {Math.min(indexOfLastBill, proposallist?.length)} {t("of")} {proposallist?.length} {t("entries")}</p>
//                                     </div>
//                                     <div className='col-6 text-end' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
//                                         <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
//                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px' }}>&laquo;</button>
//                                         <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
//                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&lt;</button>
//                                         <button
//                                             style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', border: '1px solid lightgrey', borderLeft: "none" }}>
//                                             {currentPage}
//                                         </button>
//                                         <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
//                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&gt;</button>
//                                         <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
//                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&raquo;</button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>



//                 </div>

//                 {
//                     selectedProposal && (
//                         <div
//                             onClick={() => setSelectedProposal(null)}
//                             style={{
//                                 position: 'fixed',
//                                 top: 0, left: 0,
//                                 width: '100vw',
//                                 height: '100vh',
//                                 backgroundColor: 'rgba(0, 0, 0, 0.84)',
//                                 display: 'flex',
//                                 justifyContent: 'center',
//                                 alignItems: 'center',
//                                 zIndex: 9999
//                             }}
//                         >
//                             <div
//                                 onClick={(e) => e.stopPropagation()}
//                                 style={{
//                                     backgroundColor: 'white',
//                                     padding: '40px 40px',
//                                     borderRadius: '20px',
//                                     width: '50%',
//                                     maxHeight: '90vh',
//                                     overflow: "hidden",
//                                     boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//                                     position: 'relative'
//                                 }}
//                             >

//                                 <div className="col-12">

//                                     <div className="col-12  mb-3">
//                                         <div className="row">
//                                             <div className="col-6">
//                                                 <h5 className='fw-bold'>{t("Bill Details")}</h5>
//                                             </div>

//                                             <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                                                 <button
//                                                     onClick={() => setSelectedProposal(null)}
//                                                     style={{
//                                                         width: '32px',
//                                                         height: '32px',
//                                                         borderRadius: '50%',
//                                                         backgroundColor: 'red',
//                                                         border: 'none',
//                                                         display: 'flex',
//                                                         justifyContent: 'center',
//                                                         alignItems: "center",
//                                                         cursor: 'pointer',
//                                                         fontSize: '24px',
//                                                         fontWeight: 'bold',
//                                                         color: 'white',
//                                                         lineHeight: 1
//                                                     }}
//                                                 >
//                                                     ×
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-12" style={{ height: "59vh", overflowX: "hidden", overflowY: "scroll", scrollBehavior: "smooth" }}>
//                                         <table style={{ width: '100%', height: "100%", borderCollapse: 'collapse' }}>
//                                             <tbody>
//                                                 {Object.entries(selectedProposal).map(([key, value], index) => (
//                                                     <>
//                                                         <tr key={key} style={{ backgroundColor: index % 2 === 0 ? '#2B75D5' : '#cce0f9', border: '1px solid #cce0f9' }}>
//                                                             <td style={{
//                                                                 fontWeight: 'bold',
//                                                                 padding: '8px',
//                                                                 width: '40%',
//                                                                 backgroundColor: '#2B75D5',
//                                                                 color: 'white',
//                                                                 border: '1px solid #cce0f9'
//                                                             }}>
//                                                                 {key}
//                                                             </td>
//                                                             <td style={{
//                                                                 padding: '8px',
//                                                                 color: "black",
//                                                                 backgroundColor: index % 2 === 0 ? '#E3EBF5' : '#D0DEF1',

//                                                             }}>
//                                                                 {/* Handle Upload Bill Copy link */}
//                                                                 {key === 'Release Draft Copy' && value ? (
//                                                                     <a href={`${apiurl}/FinancialReleaseGR/${value}`} target="_blank" rel="noreferrer">
//                                                                         {value}
//                                                                     </a>
//                                                                 ) : value === null || value === '' ? (
//                                                                     '-'
//                                                                 ) : (
//                                                                     value.toString()
//                                                                 )}
//                                                             </td>

//                                                         </tr>

//                                                     </>
//                                                 ))}
//                                             </tbody>
//                                         </table>
//                                     </div>

//                                 </div>

//                             </div>
//                         </div>
//                     )}
//             </div>

//         </>

//     )
// }

// export default LimitOutward;




import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../../StateContext/Application';
import { apiurl } from '../../../../../path';
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
const LimitOutward = () => {
    const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetBudgetHeadInfo, TechnicalOutwards ,Usermenu} = context;

    const [LimitType, setLimitType] = useState('Work');
    const [statusofData, setstatusofData] = useState("Pending");
    const [technicalInwards, setTechnicalInwards] = useState([])
    const [selectedBills, setSelectedBills] = useState([]);
    const [filteredBills, setFilteredBills] = useState([]);
    const [selectedProposal, setSelectedProposal] = useState(null);
    const [proposallist, setProposalList] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [UserRole, setUserRole] = useState("");
    const [AllDistrict, setAllDistrict] = useState([]);
    const [TalukasofDistrict, setTalukasofDistrict] = useState([]);

   const [SelectedDistrict, setSelectedDistrict] = useState([]);
const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] = useState([]);
const[RoleID,setroleID]=useState(null)
const [typeofData, settypeofData] = useState("District");
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');
    const budgetEstimation = proposallist;

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
     const sortedBills = Array.isArray(filteredBills)? filteredBills.slice() // ✅ prevent state mutation
         .sort((a, b) => new Date(b.Date) - new Date(a.Date))
        : [];
    const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
const [exportingPDF, setExportingPDF] = useState(false);

  const displayedGRS = exportingPDF ? filteredBills : currentBills;
const [openDistrict, setOpenDistrict] = useState(false);
const [openTaluka, setOpenTaluka] = useState(false);
const [loading, setloading] = useState(false)
    const headerStyle = {
        padding: "12px 16px",
        whiteSpace: "nowrap",
        borderRight: "1px solid #e0e0e0",
        textTransform: "capitalize",
    };


    const getTechnicalInwardsList = async () => {
        let data = await GetBudgetHeadInfo('All', 'GetDemandGenerationList')
        let data1 = await TechnicalOutwards("LimitAllocation");

        const { status, message, Tabletype } = data1
        if (status) {
            console.log("data------------", data1);
            setTechnicalInwards(message)
            setProposalList(message);
            setUserRole(Tabletype);
        }
        else {
            alert(message);
        }
    }

     const getmenu = async () => {
  try {
    const data = await Usermenu();
    if (!data || typeof data !== "object") {
      console.error("Invalid data:", data);
      return;
    }
    const roleID = data?.Data?.RoleID;
      setroleID(roleID)
  console.log("sffdsf",data?.Data)
  } catch (error) {
    console.error("Error in AdminNavbar getmenu:", error);
  }
};
    useEffect(() => {
        getTechnicalInwardsList();
           getmenu();
    }, []);

useEffect(() => {
        setSelectedTalukasofDistrict("");
    }, [SelectedDistrict]);

    const allDistricts = [
  ...new Set(AllDistrict?.map(d => d.District_Marathi))
];
const isAllSelected =
  SelectedDistrict.length === allDistricts.length;

  const toggleAllDistricts = () => {
  setSelectedDistrict(isAllSelected ? [] : allDistricts);
};
    
    const toggleDistrict = (district) => {
  setSelectedDistrict(prev =>
    prev.includes(district)
      ? prev.filter(d => d !== district)
      : [...prev, district]
  );
};

useEffect(() => {
  let filtered = [...technicalInwards];
 if (
      typeofData === "District" &&
      RoleID === 29
    ) {
      filtered = filtered.filter(
        (item) =>
          item.HeadCode ===
          "3054-2419(Roads and bridge repair maintenance program)",
      );
      console.log("filtered Date 3054",filtered)
    } else if (
      typeofData === "State" &&
      RoleID === 29
    ) {
      filtered = filtered.filter(
        (item) => item.HeadCode === "2515-1238(MLA Representative)",
      );
    }

  filtered = filtered.filter(item => {
    if (LimitType && item.Release_Type !== LimitType) return false;

    // ✅ MULTI District filter
    if (SelectedDistrict?.length > 0 && !SelectedDistrict.includes(item.District)) {
      return false;
    }

    // ✅ SINGLE Taluka filter
    if (SelectedTalukasofDistrict && item.Taluka !== SelectedTalukasofDistrict) {
      return false;
    }

    // ✅ Status filter
    if (statusofData) {
      if (statusofData === "false") {
        return (
          item.Status !== "Rejected" &&
          (item.Approvance1 === "false" ||
           item.Approvance2 === "false")
        );
      }
       if (statusofData === "Approved") {
    return (
      item.Approvance1 === "true" &&
      item.Approvance2 === "true"
    );
  }

      if (statusofData === "Rejected") {
        return item.Status === "Rejected";
      }
    }

    return true;
  });

  
  // 🔍 Search
  if (searchTerm.trim()) {
    const lower = searchTerm.toLowerCase();
    filtered = filtered.filter(item =>
      Object.values(item).some(val =>
        String(val ?? "").toLowerCase().includes(lower)
      )
    );
  }

  setFilteredBills(filtered);
  setCurrentPage(1);

}, [
  technicalInwards,
  LimitType,
  SelectedDistrict,
  SelectedTalukasofDistrict,
  statusofData,
  searchTerm,
  typeofData
]);

    const selectedBillDetails = (BillID, year) => {
        if (LimitType === "Proposal") {
            const result = budgetEstimation
                .filter(item => item.ProposalID == BillID)
                .map(item => ({
                    "Release UID": item.ReleaseID,
                    "Proposal Name": item.ProposalID,
                    "Head Code": item.HeadCode,
                    "District": item.District,
                    "Taluka": item.Taluka,
                    "Proposal Cost": item.ProposalCost,
                    "Limit Allocated": item.OriginalLimitAllocatedAmount,
                    "Release Amount Till Date": item.ReleaseAmountTillDate,
                    "Release Draft Copy": item.ReleaseSanctionCopy,
                    "Date": new Date(item.Date).toLocaleString(),
                }));


            console.log("------------------", result)
            setSelectedProposal(result[0]);
        }
        else if (LimitType === "Head") {
            const result = budgetEstimation
                .filter(item => item.Release_Type == "Head" && item.HeadCode == BillID && item.FinancialYear == year)
                .map(item => ({
                    "Release UID": item.ReleaseID,
                    "Head Code": item.HeadCode,
                    "Head Name": item.BudgetHead,
                    "District": item.District,
                    "Limit Allocated": item.OriginalLimitAllocatedAmount,
                    "Release Amount Till Date": item.ReleaseAmountTillDate,
                    "Date": new Date(item.Date).toLocaleString(),
                }));


            console.log("------------------", result)
            setSelectedProposal(result[0]);
        }
    }


    const FetchGramPanachayatInfo = async () => {
        try {
            let res = await GetBudgetHeadInfo('null', "AllDistrict");
            // console.log("Data i get:: ", res);
            setAllDistrict(res);
        }
        catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        FetchGramPanachayatInfo();
    }, []);


useEffect(() => {
  if (SelectedDistrict?.length > 0) {
    const res = AllDistrict.filter(item =>
      SelectedDistrict.includes(item.District_Marathi)
    );

     if (SelectedDistrict.length > 1) {
    setTalukasofDistrict([]);
  } else {
    setTalukasofDistrict(res);
  }
  } else {
    setTalukasofDistrict([]);
    setSelectedTalukasofDistrict("");
  }
}, [SelectedDistrict, AllDistrict]);
          const totalBillamt = filteredBills?.reduce((sum, item) => {
  const amount = Number(item?.OriginalLimitAllocatedAmount);
  return sum + (isNaN(amount) ? 0 : amount);
}, 0);
   const totalpayableamt = filteredBills?.reduce((sum, item) => {
  const amount = Number(item?.ReleaseAmountTillDate);
  return sum + (isNaN(amount) ? 0 : amount);
}, 0);

 const exportTableByClassToExcel = async(
  filteredBills,
  filename = "Limitallocation.xlsx"
) => {
  if (!Array.isArray(filteredBills) || filteredBills.length === 0) {
    alert("No data available");
    return;
  }
  setloading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
try {
  let totalLimitAllocated = 0;
  let totalReleasedAmount = 0;

  const excelData = filteredBills.map((proposal, index) => {
    const limitAllocated = Number(proposal.OriginalLimitAllocatedAmount || 0);
    const releasedTillDate = Number(proposal.ReleaseAmountTillDate || 0);

    totalLimitAllocated += isNaN(limitAllocated) ? 0 : limitAllocated;
    totalReleasedAmount += isNaN(releasedTillDate) ? 0 : releasedTillDate;

    return {
      "Sr.No": index + 1,
      "Work Name": proposal.ProposalID || "-",
      "Release UID": proposal.ReleaseID || "-",
      "Head Code": proposal.HeadCode || "-",
      "District": proposal.District || "-",
      "Taluka": proposal.Taluka || "-",
      "Work Cost": proposal.ProposalCost || 0,
      "MHUID Number": proposal.MH_UID || "-",
      "Physical Value (%)": proposal.physicalValue || 0,

      "Limit Allocated": limitAllocated,
      "Release Amount Till Date": releasedTillDate,

      "Date": proposal.Date
        ? new Date(proposal.Date).toLocaleString()
        : "",

      "Rejected?": proposal.Status === "Pending" ? "No" : "Yes",
      "Remark": proposal.Remark || "--",

      "RDD Section Officer":
        proposal.Approvance1 === "true"
          ? "✓"
          : proposal.Approvance1 === "false"
          ? "✕"
          : "-",

      "Deputy Secretary":
        proposal.Approvance2 === "true"
          ? "✓"
          : proposal.Approvance2 === "false"
          ? "✕"
          : "-"
    };
  });

  /* ---------- TOTAL ROW ---------- */
  excelData.push({
    "Sr.No": "",
    "Work Name": "TOTAL",
    "Release UID": "",
    "Head Code": "",
    "District": "",
    "Taluka": "",
    "Work Cost": "",
    "MHUID Number": "",
    "Physical Value (%)": "",

    "Limit Allocated": totalLimitAllocated,
    "Release Amount Till Date": totalReleasedAmount,

    "Date": "",
    "Rejected?": "",
    "Remark": "",
    "RDD Section Officer": "",
    "Deputy Secretary": ""
  });

  /* ================= EXCEL CONFIG ================= */

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 22 }));

  worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

  // Autofilter (exclude TOTAL row)
  worksheet["!autofilter"] = {
    ref: XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: {
        r: excelData.length - 2,
        c: Object.keys(excelData[0]).length - 1
      }
    })
  };

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Limit Allocation");
  XLSX.writeFile(workbook, filename);
 } catch (error) {
    console.error("Excel Export Error:", error);
  } finally {
    setloading(false); // ✅ ALWAYS stop loader
  }
};
//    const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
//   setExportingPDF(true);
//   await new Promise(res => setTimeout(res, 300));

//   const table = document.querySelector(`.${tableClass}`);
//   if (!table) {
//     setExportingPDF(false);
//     return;
//   }

//   const pdf = new jsPDF("p", "mm", "a4");
//   const pageWidth = pdf.internal.pageSize.getWidth();
//   const pageHeight = pdf.internal.pageSize.getHeight();

//   const topMargin = 25;
//   const sideMargin = 10;
//   const bottomMargin = 15;

//   pdf.setFontSize(16);
//   pdf.setFont("helvetica", "bold");
//   pdf.text(title, pageWidth / 2, 15, { align: "center" });

//   const canvas = await html2canvas(table, {
//     scale: 1,
//     useCORS: true,
//     backgroundColor: "#2C78DB",
//   });

//   const imgWidth = pageWidth - sideMargin * 2;

//   // 🔥 Correct pixel-to-mm ratio
//   const pxToMm = imgWidth / canvas.width;

//   const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
//   const usablePageHeightPx = usablePageHeightMm / pxToMm;

//   let renderedHeight = 0;
//   let pageNumber = 0;

//   while (renderedHeight < canvas.height) {
//     const sliceHeight = Math.min(
//       usablePageHeightPx,
//       canvas.height - renderedHeight
//     );

//     const pageCanvas = document.createElement("canvas");
//     const context = pageCanvas.getContext("2d");

//     pageCanvas.width = canvas.width;
//     pageCanvas.height = sliceHeight;

//     context.drawImage(
//       canvas,
//       0,
//       renderedHeight,
//       canvas.width,
//       sliceHeight,
//       0,
//       0,
//       canvas.width,
//       sliceHeight
//     );

//     const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);

//     if (pageNumber > 0) pdf.addPage();

//     pdf.addImage(
//       imgData,
//       "JPEG",
//       sideMargin,
//       topMargin,
//       imgWidth,
//       sliceHeight * pxToMm
//     );

//     renderedHeight += sliceHeight;
//     pageNumber++;
//   }

//   pdf.save(filename);
//   setExportingPDF(false);
// };

const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  const CHUNK_SIZE = 500; // 🔥 Adjust if needed

  setExportingPDF(true);

  const originalTable = document.querySelector(`.${tableClass}`);
  if (!originalTable) {
    setExportingPDF(false);
    return;
  }
setloading(true)
  await new Promise(res => setTimeout(res, 300));

  try {
    const originalRows = originalTable.querySelectorAll("tbody tr");
    const totalRows = originalRows.length;

    for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
      const end = Math.min(start + CHUNK_SIZE, totalRows);

      // 🔥 Clone only required rows
      const table = originalTable.cloneNode(true);
      const rows = table.querySelectorAll("tbody tr");

      rows.forEach((row, index) => {
        if (index < start || index >= end) {
          row.remove();
        }
      });

      document.body.appendChild(table);

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const topMargin = 25;
      const sideMargin = 10;
      const bottomMargin = 15;

      pdf.setFontSize(16);
      pdf.setFont("helvetica", "bold");
      pdf.text(
        `${title} (${start + 1} - ${end})`,
        pageWidth / 2,
        15,
        { align: "center" }
      );

      const canvas = await html2canvas(table, {
        scale: 1,
        useCORS: true,
        backgroundColor: "#2C78DB",
      });

      const imgWidth = pageWidth - sideMargin * 2;
      const pxToMm = imgWidth / canvas.width;

      const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
      const usablePageHeightPx = usablePageHeightMm / pxToMm;

      let renderedHeight = 0;
      let pageNumber = 0;

      while (renderedHeight < canvas.height) {
        const sliceHeight = Math.min(
          usablePageHeightPx,
          canvas.height - renderedHeight
        );

        const pageCanvas = document.createElement("canvas");
        const context = pageCanvas.getContext("2d");

        pageCanvas.width = canvas.width;
        pageCanvas.height = sliceHeight;

        context.drawImage(
          canvas,
          0,
          renderedHeight,
          canvas.width,
          sliceHeight,
          0,
          0,
          canvas.width,
          sliceHeight
        );

        const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

        if (pageNumber > 0) pdf.addPage();

        pdf.addImage(
          imgData,
          "JPEG",
          sideMargin,
          topMargin,
          imgWidth,
          sliceHeight * pxToMm
        );

        renderedHeight += sliceHeight;
        pageNumber++;
      }

      pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

      document.body.removeChild(table);

      // 🔥 Small delay to prevent freezing
      await new Promise(res => setTimeout(res, 250));
    }

  } catch (error) {
    console.error("PDF Export Error:", error);
  }
setloading(false); 
  setExportingPDF(false);
};
    return (

        <>

            <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" ,position: "relative" }}>
 {/* 🔥 Blur Wrapper */}
    <div
      style={{
        filter: loading ? "blur(4px)" : "none",
        pointerEvents: loading ? "none" : "auto",
        transition: "0.2s ease",
      }}
    > 
                <div className="col-11 m-auto">
                <div
          className="col-12 px-4 mb-4 mt-3"
          style={{
            filter: loading ? "blur(4px)" : "none",
            pointerEvents: loading ? "none" : "auto",
            transition: "0.2s ease",
          }}
        >


                {/* ================= ROW 1 : Heading + Download ================= */}
                <div
                                     className="d-flex justify-content-between align-items-center mb-2 flex-wrap"

                >
                    <h5 className="fw-bold d-flex align-items-center m-0">
                    <img
                        src="/Work-Order-Outwards-Blue64.png"
                        alt="Limit Allocation"
                        style={{ width: "24px", height: "24px", marginRight: "6px" }}
                    />
   {[24, 25, 29, 40, 41].includes(RoleID)
  ? t("Limit Allocation Status")
  : t("Limit Allocation Outward")}
                    </h5>
<div className="d-flex gap-2"> 
                    <button
                    className="btn btn-success"
                    onClick={() =>
                        exportTableByClassToExcel(filteredBills, "LimitAllocationOutward.xlsx")
                    }
                    >
                    {t("Download Excel")}
                    </button>
                      <button
      className="btn btn-danger"
      onClick={() =>
        downloadTableOnlyAsPDF(
          "LimitOutward",
          "LimitOutward.pdf",
          "LimitOutward Report"
        )
      }
    >
      {t("Download PDF")}
    </button>
  </div>
                </div>

                {/* ================= ROW 2 : Filters + Search ================= */}
                <div
                    style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "nowrap"
                    }}
                >
                    {UserRole === "State" && RoleID == 29 && (
                  <select
                    value={typeofData}
                    onChange={(e) => settypeofData(e.target.value)}
                    style={{
                      width: "150px",
                      padding: "8px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                       fontSize:"13px"  , whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                    }}
                  >
                    <option value="" disabled selected>
                      Choose Data
                    </option>
                    <option value="District" >{t("3054-2419(Roads and bridge repair maintenance program)")}</option>
                    <option value="State">{t("2515-1238(MLA Representative)")}</option>
                  </select>
                )} 
                    {/* Status */}
                    <select
                    value={statusofData}
                    onChange={(e) => setstatusofData(e.target.value)}
                    style={{
                        width: "150px",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                         fontSize: "13px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    }}
                    >
                    <option value="">{t("All")}</option>
                    <option value="Approved">{t("Approved")}</option>
                    <option value="false">{t("Pending")}</option>
                    <option value="Rejected">{t("Rejected")}</option>
                    </select>

                 {UserRole === "State" && (
  <div style={{ position: "relative", width: "150px" }}>
    {/* Trigger */}
    <div
      onClick={() => setOpenDistrict(!openDistrict)}
      style={{
        padding: "8px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        background: "#fff",
        cursor: "pointer",
        fontSize: "13px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }}
    >
      {SelectedDistrict.length > 0
        ? SelectedDistrict.join(", ")
        :t("Select District")}
    </div>

    {/* Dropdown */}
    {openDistrict && (
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          width: "100%",
          background: "#fff",
          border: "1px solid #ccc",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
          zIndex: 10
        }}
      >
           <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "6px 8px",
            borderBottom: "1px solid #eee",
            cursor: "pointer",
            fontSize:"13px"  , 
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={toggleAllDistricts}
            style={{ marginRight: "6px" }}
          />
          {t("All Districts")}
        </label>
        <div style={{ maxHeight: "150px", overflowY: "auto" }}>
          {[...new Set(AllDistrict?.map(d => d.District_Marathi))].map(
            (district, index) => (
              <label
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "6px 8px",
                  cursor: "pointer",
                  fontSize:"13px"  , 
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
              >
                <input
                  type="checkbox"
                  checked={SelectedDistrict.includes(district)}
                  onChange={() => toggleDistrict(district)}
                  onClick={(e) => e.stopPropagation()}
                  style={{ marginRight: "6px" }}
                />
                {district}
              </label>
            )
          )}
        </div>

        <div style={{ textAlign: "right", padding: "6px" }}>
          <button
            onClick={() => setOpenDistrict(false)}
            style={{
              padding: "4px 10px",
              fontSize: "12px",
              borderRadius: "6px",
              border: "none",
              background: "#0d6efd",
              color: "#fff",
              cursor: "pointer"
            }}
          >
            OK
          </button>
        </div>
      </div>
    )}
  </div>
)}


                    {/* Taluka */}
                    {UserRole === "State" && (
                    <select
                        value={SelectedTalukasofDistrict}
                        onChange={(e) => setSelectedTalukasofDistrict(e.target.value)}
                        style={{
                        width: "150px",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                         fontSize: "13px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                        }}
                    >
                        <option value="">Select Taluka</option>
                        {TalukasofDistrict?.map((val, index) => (
                        <option key={index} value={val.ULBNameMarathi}>
                            {val.ULBNameMarathi}
                        </option>
                        ))}
                    </select>
                    )}

                    {/* Search */}
                    <div style={{ position: "relative", width: "180px" }}>
                    <img
                        src="/Search32.png"
                        alt="Search"
                        style={{
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        width: "16px",
                        opacity: 0.6
                        }}
                    />
                    <input
                        type="text"
                        placeholder={t("Search Here")}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                        width: "100%",
                        padding: "8px 12px 8px 32px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f1f6fc",
                         fontSize: "13px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                        }}
                    />
                    </div>
                </div>

                </div>

                    <div className="col-12 pb-5">
                        <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px" }}>

                            <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
                                {
                                    LimitType == "Work" &&
                                    <table className='m-0 p-0 LimitOutward' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px", fontWeight: "400" }}>
                                                <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Sr.No.")}</th>
                                                <th style={{ minWidth: "180px", padding: "12px" }} rowSpan={2} colSpan={1}>{t("Work Name")}</th>
                                                <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Job ID")}</th>
                                                <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Release UID")}</th>
                                                {UserRole==="State" && RoleID!=29 ? "":<th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("Head Code")}</th>}
                                                <th style={headerStyle} rowSpan={2} colSpan={1}>{t("District")}</th>
                                                <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Taluka")}</th>
                                                <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Work Cost")}</th>
                                                <th style={headerStyle} rowSpan={2} colSpan={1}>{t("MHUID Number")}</th>
                                                <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Physical Progress In %")}</th>
                                                <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Limit Allocated")}</th>
                                                <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Release Amount Till Date")}</th>

                                                <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("Date")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "160px" }} rowSpan={2}>{t("Rejected?")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "160px" }} rowSpan={2}>{t("Remark")}</th>
                                                <th style={headerStyle} colSpan={2}>{t("Approved by")}</th> {/* changed from 9 to 7 */}

                                            </tr>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px", fontWeight: "400" }}>
                                                <th style={headerStyle}>{t("RDD Section Officer")}</th>
                                                <th style={headerStyle}>{t("Deputy Secretary")}</th>
                                            </tr>
                                        </thead>

                                        <tbody >
                                            <>
                                            {displayedGRS?.length === 0 ? (
                                                <tr>
                                                    <td colSpan="30" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                        {t("No data available")}
                                                    </td>
                                                </tr>
                                            ) : (
                                                displayedGRS?.map((proposal, index) => {
                                                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                    return (
                                                        <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }} key={index}>
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{indexOfFirstBill + index + 1}</td>
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.ProposalID}</td>
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.JOB_ID}</td>
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.ReleaseID}</td>
                                                           {UserRole==="State"&& RoleID!=29 ? "" : <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.HeadCode}</td>}
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.District}</td>
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.Taluka}</td>
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.ProposalCost}</td>
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.MH_UID}</td>
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.physicalValue}</td>
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.OriginalLimitAllocatedAmount}</td>
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{proposal.ReleaseAmountTillDate}</td>
                                                            {/* <td style={{ padding: '8px' }}>
                                                                {proposal.ReleaseSanctionCopy ? (
                                                                    <a href={`${apiurl}/FinancialReleaseGR/${proposal.ReleaseSanctionCopy}`} target="_blank" rel="noreferrer">{proposal.ReleaseSanctionCopy}</a>
                                                                ) : (
                                                                    <p className='text-danger my-auto fw-bold'>No File</p>
                                                                )
                                                                }
                                                            </td> */}
                                                            <td style={{ fontSize: "12px", padding: "5px" }}>{new Date(proposal.Date).toLocaleString()}</td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.Status === 'Pending' ? 'No' : 'Yes'}</td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.Remark || "--"}</td>
                                                            <td style={{ padding: '8px', textAlign: 'center' }}>
                                                                {proposal.Approvance1 === 'true' ? (
                                                                    <div className='m-auto'
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            borderRadius: '6px',
                                                                            backgroundColor: '#16C60C',
                                                                            border: 'none',
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                            fontSize: '13px',
                                                                            color: 'white',
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    >
                                                                        ✓
                                                                    </div>
                                                                ) : proposal.Approvance1 === 'false' ? (
                                                                    <div
                                                                        className='m-auto'
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            borderRadius: '6px',
                                                                            backgroundColor: '#dc2626',
                                                                            border: 'none',
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                            fontSize: '13px',
                                                                            color: 'white',
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    >
                                                                        ✕
                                                                    </div>
                                                                ) : '-'}
                                                            </td>
                                                            <td style={{ padding: '8px', textAlign: 'center' }}>
                                                                {proposal.Approvance2 === 'true' ? (<div className='m-auto'
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        borderRadius: '6px',
                                                                        backgroundColor: '#16C60C',
                                                                        border: 'none',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        fontSize: '13px',
                                                                        color: 'white',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                    }}
                                                                >
                                                                    ✓
                                                                </div>) : proposal.Approvance2 === 'false' ? (<div
                                                                    className='m-auto'
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        borderRadius: '6px',
                                                                        backgroundColor: '#dc2626',
                                                                        border: 'none',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        fontSize: '13px',
                                                                        color: 'white',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                    }}
                                                                >
                                                                    ✕
                                                                </div>) : '-'}
                                                            </td>

                                                            {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
                                                            {/* <td>
                                                            <button
                                                                className='m-auto'
                                                                onClick={() => selectedBillDetails(proposal.ProposalID)}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    padding: '8px 20px',
                                                                    borderRadius: '4px',
                                                                    fontSize: "12px",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: 'center'
                                                                }}
                                                            >
                                                                <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
                                                                View
                                                            </button>
                                                        </td> */}
                                                        </tr>

                                                    );
                                                })
                                            )}
                                                                      <tr
        style={{
          fontWeight: "600",
          backgroundColor: "#f0f0f0",
          fontSize: "13px",
        }}
      >
        <td colSpan={UserRole=="State" && RoleID!=29 ?8:9} style={{ textAlign: "left", padding: "8px" }}>
          {t("Total")}
        </td>

        <td style={{ padding: "8px" }}  >
          ₹ {totalBillamt.toLocaleString("en-IN")}
        </td>
  <td style={{ padding: "8px" }}  >
          ₹ {totalpayableamt.toLocaleString("en-IN")}
        </td>
      
        {/* remaining columns */}
        <td colSpan={UserRole=="State"?19:20}></td>
      </tr>
                                                     </>
                                        </tbody>
                                    </table>
                                }
                                {
                                    LimitType == "Head" &&
                                    <table className='m-0 p-0 LimitOutward' style={{ width: "100%" }}>
                                        <thead>
                                            <tr style={{ color: 'white', border: 'none', height: '3.5rem' }}>
                                                <th style={{ width: "25%", border: "1px solid white" }} rowSpan={2} colSpan={1}>{t("Head Name")}</th>
                                                <th style={{ width: "40%", border: "1px solid white" }} colSpan={2}>{t("Approved by")}</th> {/* changed from 9 to 7 */}
                                                <th style={{ width: "15%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>{t("Details")}</th>
                                            </tr>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
                                                <th style={{ width: "20%", border: "1px solid white" }}>{t("RDD Section Officer")}</th>
                                                <th style={{ width: "20%", border: "1px solid white" }}>{t("Deputy Secretary")}</th>
                                            </tr>
                                        </thead>

                                        <tbody >
                                            {displayedGRS?.length === 0 ? (
                                                <tr>
                                                    <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                        {t("No data available")}
                                                    </td>
                                                </tr>
                                            ) : (
                                                displayedGRS?.map((proposal, index) => {
                                                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                    return (
                                                        <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }} key={index}>
                                                            <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.BudgetHead}</td>
                                                            <td style={{ padding: '8px', textAlign: 'center' }}>
                                                                {proposal.Approvance1 === 'true' ? (
                                                                    <div className='m-auto'
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            borderRadius: '6px',
                                                                            backgroundColor: '#16C60C',
                                                                            border: 'none',
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                            fontSize: '13px',
                                                                            color: 'white',
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    >
                                                                        ✓
                                                                    </div>
                                                                ) : proposal.Approvance1 === 'false' ? (
                                                                    <div
                                                                        className='m-auto'
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            borderRadius: '6px',
                                                                            backgroundColor: '#dc2626',
                                                                            border: 'none',
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                            fontSize: '13px',
                                                                            color: 'white',
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    >
                                                                        ✕
                                                                    </div>
                                                                ) : '-'}
                                                            </td>
                                                            <td style={{ padding: '8px', textAlign: 'center' }}>
                                                                {proposal.Approvance2 === 'true' ? (<div className='m-auto'
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        borderRadius: '6px',
                                                                        backgroundColor: '#16C60C',
                                                                        border: 'none',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        fontSize: '13px',
                                                                        color: 'white',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                    }}
                                                                >
                                                                    ✓
                                                                </div>) : proposal.Approvance2 === 'false' ? (<div
                                                                    className='m-auto'
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        borderRadius: '6px',
                                                                        backgroundColor: '#dc2626',
                                                                        border: 'none',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        fontSize: '13px',
                                                                        color: 'white',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                    }}
                                                                >
                                                                    ✕
                                                                </div>) : '-'}
                                                            </td>

                                                            {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
                                                            <td>
                                                                <button
                                                                    className='m-auto'
                                                                    onClick={() => selectedBillDetails(proposal.BudgetHeadID, proposal.FinancialYear)}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        padding: '8px 20px',
                                                                        borderRadius: '4px',
                                                                        fontSize: "12px",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: 'center'
                                                                    }}
                                                                >
                                                                    <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
                                                                    {t("View")}
                                                                </button>
                                                            </td>
                                                        </tr>

                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                }
                            </div>
                            <div className='col-12 mt-4'>
                                <div className="row">
                                    <div className='col-6'>
                                        <p className="text-gray-600" style={{ fontSize: "14px", margin: 0 }}>{t("Showing")} {indexOfFirstBill + 1} {t("to")} {Math.min(indexOfLastBill, filteredBills?.length)} {t("of")} {filteredBills?.length} {t("entries")}</p>
                                    </div>
                                    <div className='col-6 text-end' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                                        <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px' }}>&laquo;</button>
                                        <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
                                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&lt;</button>
                                        <button
                                            style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', border: '1px solid lightgrey', borderLeft: "none" }}>
                                            {currentPage}
                                        </button>
                                        <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}
                                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&gt;</button>
                                        <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages || totalPages === 0}
                                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&raquo;</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>

                {
                    selectedProposal && (
                        <div
                            onClick={() => setSelectedProposal(null)}
                            style={{
                                position: 'fixed',
                                top: 0, left: 0,
                                width: '100vw',
                                height: '100vh',
                                backgroundColor: 'rgba(0, 0, 0, 0.84)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 9999
                            }}
                        >
                            <div
                                onClick={(e) => e.stopPropagation()}
                                style={{
                                    backgroundColor: 'white',
                                    padding: '40px 40px',
                                    borderRadius: '20px',
                                    width: '50%',
                                    maxHeight: '90vh',
                                    overflow: "hidden",
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                                    position: 'relative'
                                }}
                            >

                                <div className="col-12">

                                    <div className="col-12  mb-3">
                                        <div className="row">
                                            <div className="col-6">
                                                <h5 className='fw-bold'>{t("Bill Details")}</h5>
                                            </div>

                                            <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <button
                                                    onClick={() => setSelectedProposal(null)}
                                                    style={{
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '50%',
                                                        backgroundColor: 'red',
                                                        border: 'none',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: "center",
                                                        cursor: 'pointer',
                                                        fontSize: '24px',
                                                        fontWeight: 'bold',
                                                        color: 'white',
                                                        lineHeight: 1
                                                    }}
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12" style={{ height: "59vh", overflowX: "hidden", overflowY: "scroll", scrollBehavior: "smooth" }}>
                                        <table style={{ width: '100%', height: "100%", borderCollapse: 'collapse' }}>
                                            <tbody>
                                                {Object.entries(selectedProposal).map(([key, value], index) => (
                                                    <>
                                                        <tr key={key} style={{ backgroundColor: index % 2 === 0 ? '#2B75D5' : '#cce0f9', border: '1px solid #cce0f9' }}>
                                                            <td style={{
                                                                fontWeight: 'bold',
                                                                padding: '8px',
                                                                width: '40%',
                                                                backgroundColor: '#2B75D5',
                                                                color: 'white',
                                                                border: '1px solid #cce0f9'
                                                            }}>
                                                                {key}
                                                            </td>
                                                            <td style={{
                                                                padding: '8px',
                                                                color: "black",
                                                                backgroundColor: index % 2 === 0 ? '#E3EBF5' : '#D0DEF1',

                                                            }}>
                                                                {/* Handle Upload Bill Copy link */}
                                                                {key === 'Release Draft Copy' && value ? (
                                                                    <a href={`${apiurl}/FinancialReleaseGR/${value}`} target="_blank" rel="noreferrer">
                                                                        {value}
                                                                    </a>
                                                                ) : value === null || value === '' ? (
                                                                    '-'
                                                                ) : (
                                                                    value.toString()
                                                                )}
                                                            </td>

                                                        </tr>

                                                    </>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>

                            </div>
                        </div>
                    )}
            </div>
{loading && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(255,255,255,0.4)",
          backdropFilter: "blur(2px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <div className="Adminloader"></div>
      </div>
    )}
  </div>
        </>

    )
}

export default LimitOutward;